import {Object3D} from '@wonderlandengine/api';
import {Puzzle} from '../components/puzzle.js';
import {Tags} from '../components/tags.js';
import {LevelDependentPieces} from './LevelDependentPieces.js';

export class PuzzleUtils {
    public static computeSpawnQualityNewRow(
        newRow: LevelDependentPieces[],
        column: number,
        searchTag: string,
        puzzle: Puzzle
    ): number {
        const columnCount = puzzle.lanes.length;

        let weight = PuzzleUtils.computeSpawnQuality(-1, column, searchTag, puzzle);

        const leftIndex = column > 0 ? column - 1 : columnCount - 1;
        const rightIndex = column + 1 < columnCount ? column + 1 : 0;

        if (newRow[leftIndex] != null && newRow[leftIndex].tag === searchTag) {
            weight -= 0.4;
        }
        if (newRow[rightIndex] != null && newRow[rightIndex].tag === searchTag) {
            weight -= 0.4;
        }

        const twoLeftIndex = leftIndex > 0 ? leftIndex - 1 : columnCount - 1;
        const twoRightIndex = rightIndex + 1 < columnCount ? rightIndex + 1 : 0;

        if (newRow[twoLeftIndex] != null && newRow[twoLeftIndex].tag === searchTag) {
            weight -= 0.2;
        }
        if (newRow[twoRightIndex] != null && newRow[twoRightIndex].tag === searchTag) {
            weight -= 0.2;
        }
        return weight;
    }

    static computeSpawnQuality(
        row: number,
        column: number,
        searchTag: string,
        puzzle: Puzzle
    ): number {
        const columnCount = puzzle.lanes.length;

        let weight = 1.0;

        if (row > -1) {
            let horizontalScanSize = 3;

            for (let x = 1; x < horizontalScanSize; x++) {
                const left = column - x >= 0 ? column - x : columnCount + (column - x);
                const right =
                    column + x < columnCount ? column + x : column + x - columnCount;

                let obj = puzzle.getObject(row, left);
                if (obj && Tags.hasTag(obj.object, searchTag)) {
                    weight -= 0.4 / x;
                }

                obj = puzzle.getObject(row, right);
                if (obj && Tags.hasTag(obj.object, searchTag)) {
                    weight -= 0.4 / x;
                }
            }
        }

        const lookBack = 4;
        const top = puzzle.getHighestOccupiedRow(column) + 1;

        const leftIndex = column > 0 ? column - 1 : columnCount - 1;
        const rightIndex = column + 1 < columnCount ? column + 1 : 0;

        for (let x = 1; x < lookBack; x++) {
            const above = row + x <= top ? row + x : -1;
            const below = row - x >= 0 ? row - x : -1;

            if (above == -1 && below == -1) {
                break;
            }

            if (above > -1) {
                const obj = puzzle.getObject(above, column);
                if (obj && Tags.hasTag(obj.object, searchTag)) {
                    weight -= 0.7 / x;
                }

                // kitty-corner search
                const leftObj = puzzle.getObject(above, leftIndex);
                if (leftObj && Tags.hasTag(leftObj.object, searchTag)) {
                    weight -= 0.4 / x;
                }

                const rightObj = puzzle.getObject(above, rightIndex);
                if (rightObj && Tags.hasTag(rightObj.object, searchTag)) {
                    weight -= 0.4 / x;
                }
            }

            if (below > -1) {
                const obj = puzzle.getObject(below, column);
                if (obj && Tags.hasTag(obj.object, searchTag)) {
                    weight -= 0.7 / x;
                }

                // kitty-corner search
                const leftObj = puzzle.getObject(below, leftIndex);
                if (leftObj && Tags.hasTag(leftObj.object, searchTag)) {
                    weight -= 0.4 / x;
                }

                const rightObj = puzzle.getObject(below, rightIndex);
                if (rightObj && Tags.hasTag(rightObj.object, searchTag)) {
                    weight -= 0.4 / x;
                }
            }
        }

        return weight;
    }
}
